export default {"src":"/uk/_next/static/media/more-meatball-menu.8b5a6801.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};